import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250516143428/app/[lng]/(home)/pre-post-harvest/[id]/product-services/ProductAndServicesComponent.tsx");
